var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 7.82862L19.6889 5.41843L12.1204 12.96L9.14013 9.97958L16.6804 2.4093L14.2717 8.56672e-05H22.1V7.82862ZM22.1 10.8V15.6C22.1 18.9599 19.4599 21.6 16.1 21.6H6.5C3.14009 21.6 0.5 18.9599 0.5 15.6V6C0.5 2.64008 3.14009 0 6.5 0H11.3V3.12004H6.5C4.82004 3.12004 3.62004 4.32004 3.62004 6V15.6C3.62004 17.2799 4.82004 18.4799 6.5 18.4799H16.1C17.78 18.4799 18.98 17.2799 18.98 15.6V10.8H22.1Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.3b34f708a75c04748ae3360c26028884.svg";
export { ForwardRef as ReactComponent };